<!-- <div *ngIf="show"
     style="position: fixed;z-index: 9999999999999; width: 100%;height: 100%;"
     class="loader-open">
    <div class="row"
         style="width: 90px; height: 90px; margin: 0 auto; position: relative; top: 40%; border-radius: 10px;">
        <div style="text-align: center"
             class="col-sm-12">
             
             <img style="margin-top: 10px; padding-right: 2px;"
                 width="70px"
                 height="70px"
                 src="images/view-loader.svg"> 
        </div>
    </div>
</div> -->

<div
  *ngIf="show$ | async"
  style="position: fixed; z-index: 9999999999999; width: 100%; height: 100%"
  class="loader-open"
>
  <div
    class="row"
    style="
      width: 90px;
      height: 90px;
      margin: 0 auto;
      position: relative;
      top: 40%;
      border-radius: 10px;
    "
  >
    <div class="col-sm-12" style="text-align: center">
      <img src="/Layer_1.svg" alt="wareed-labs" class="logo spin" loading="eager" />
      <!-- <div class="ball-loader">
                <div class="ball"></div>
                <div class="ball"></div>
                <div class="ball"></div>
            </div> -->
    </div>
  </div>
</div>
